import reactFirestore from "./ReactFirestore";

const useQueries = (queries) => {
  return reactFirestore.readQueries(queries);
};

export default useQueries;
